import {useState} from "react";
import {Language} from "../../controllers/Language";
import {Globals} from "../../controllers/Globals";
import {Alert} from "../commond/Alert";
import {cuppa, log} from "../../../cuppa/cuppa";
import {UserCtrl} from "../../controllers/UserCtrl";
import {Utils} from "../../controllers/Utils";
import {Link} from "react-router-dom";

export function ForgotPassword(){
	const [form, setForm] = useState({email:''});

	async function onSubmit(e){
		e.preventDefault(); e.stopPropagation();
		let validation = cuppa.validateFormObject(form, {email:{required:true, type:'email'}})
		if(!validation.valid){
			let message = `${cuppa.capitalize(validation.label)} ${validation.message}.`;
			Globals.mainPortal.add("Alert", <Alert key={"Alert"} message={message} title={"Error"} />)
			return;
		}
		let result = await UserCtrl.startResetPassword(form);
		if(!result?.data?.startResetPassword?.id){
			Globals.mainPortal.add("Alert", <Alert key={"Alert"} title={'Error'} message={Language.value("We do not recognize that email address.")} />);
			return;
		}

		let message = `A password reset email was sent to <strong>${form.email}</strong>. Please check your spam folder if it does not arrive.`
		Globals.mainPortal.add("Alert", <Alert key={"Alert"} html={message} title={Language.value('Please Check Your Email...')} callback={()=>{
			if(cuppa.boolean(cuppa.urlValue('hideSignIn'))) return;
			Utils.redirect("/");
		}} />);
	}

	return (
		<form onSubmit={onSubmit} style={{display:'flex', flexDirection:'column',  padding:30}}>
			<h1>{Language.value('Reset Your Password')}</h1>
			<p>Lost your password? Please enter your email. You will receive a valid link to set a new password.</p>
			<label htmlFor={"email"} className="label1" style={{marginTop:10}}>{Language.value('Email')}</label>
			<input id={"email"} defaultValue={form.email} className="input1" onChange={e=>{setForm({...form, email:e.target.value})}} />
			<button className={`button1`} style={{marginTop:15}}>
				<span>{Language.value('Send Email')}</span>
			</button>
			{!cuppa.boolean(cuppa.urlValue('hideSignIn')) && (
				<div className={'flex j-center t-center m-t-10'}>
					<span className={'m-r-5'}>Known your password?</span>
					<Link to={"/"} className={'d-i-children color-progress btn-alpha'}>{Language.value('Sign In')}</Link>
				</div>
			)}
		</form>
	)
}
